<div *ngIf="sortedControllers.length === 0" class="empty-state">
  <div class="empty-icon">📱</div>
  <h3>{{ 'controllers.empty.title' | translate }}</h3>
  <p>{{ 'controllers.empty.hint' | translate }}</p>
</div>

<!-- Offline banner -->
<div *ngIf="!isOnline" class="offline-banner" role="status" aria-live="polite">
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="12" cy="12" r="10" fill="#ff4d4f" />
    <line x1="7" y1="7" x2="17" y2="17" stroke="#fff" stroke-width="2" stroke-linecap="round" />
    <line x1="17" y1="7" x2="7" y2="17" stroke="#fff" stroke-width="2" stroke-linecap="round" />
  </svg>
  <span style="margin-left:8px;font-weight:600;">{{ 'controllers.offline' | translate }}</span>
</div>

<div *ngIf="sortedControllers.length > 1" class="reorder-toolbar">
  <ng-container *ngIf="!reorderMode">
    <button type="button" class="btn-link" (click)="startReorder()">⇅ {{ 'controllers.reorder.start' | translate }}</button>
  </ng-container>
  <ng-container *ngIf="reorderMode">
    <span class="hint">{{ 'controllers.reorder.hint' | translate }}</span>
    <button type="button" class="btn-link" (click)="cancelReorder()">{{ 'controllers.reorder.cancel' | translate }}</button>
    <button type="button" class="btn-primary" (click)="finishReorder()" [disabled]="!isOnline">{{ 'controllers.reorder.done' | translate }}</button>
  </ng-container>
</div>

<div *ngIf="sortedControllers.length > 0"
     cdkDropList [cdkDropListDisabled]="!reorderMode" (cdkDropListDropped)="onDrop($event)">
  <div *ngFor="let controller of sortedControllers; let i = index; let first = first; let last = last"
       class="controller-row" [class.reordering]="reorderMode"
       cdkDrag cdkDragLockAxis="y" [cdkDragData]="controller">
    <span *ngIf="reorderMode" class="drag-handle" cdkDragHandle
          [title]="'controllers.reorder.drag' | translate">⋮⋮</span>
    <app-controller-card class="card" [controller]="controller" [disabled]="reorderMode"></app-controller-card>
    <span *ngIf="reorderMode" class="move-buttons">
      <button type="button" (click)="move(i, -1)" [disabled]="first" [attr.aria-label]="'controllers.reorder.up' | translate">▲</button>
      <button type="button" (click)="move(i, 1)" [disabled]="last" [attr.aria-label]="'controllers.reorder.down' | translate">▼</button>
    </span>
  </div>
</div>
